export const TOKEN_KEY = "@adminModulockerCondominio:token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
